const SETTING_OWNER_LOADING = 'SETTING_OWNER_LOADING';
const SETTING_OWNER_SUCCESS = 'SETTING_OWNER_SUCCESS';
const SETTING_OWNER_FAILURE = 'SETTING_OWNER_FAILURE';

export const settingOwnerActions = {
  SETTING_OWNER_LOADING,
  SETTING_OWNER_SUCCESS,
  SETTING_OWNER_FAILURE,
};
